import { useEffect, useState } from 'react'
import { functions, auth, storage, db, timestamp } from '../firebase/config'
import { httpsCallable } from 'firebase/functions'
import { useAuthContext } from "../hooks/useAuthContext"


export const useCustomClaim = () => {
  const [ isCancelled, setIsCancelled ] = useState(false)
  const [ error, setError ] = useState(null)
  const [ isPending, setIsPending ] = useState(false)
  const { user, dispatch } = useAuthContext()



  const setCustomClaim = async (claims) => {

    const { userUid, tenantId, accessLevel, subscription } = claims
    
    setError(null)
    setIsPending(true)

    if (!user) { 
      console.log('Not authenticated user')
      setError('User not authenticated')
      setIsPending(false)
      return
    }

    // set custom claims
    //const testFunction = httpsCallable(functions, 'helloWorld')
    const updateUserProfile = httpsCallable(functions, 'updateUserProfile')

    try {
      const result = await updateUserProfile({
        userUid,
        tenantId,
        accessLevel,
        subscription
      })
      
      await user.getIdToken(true)
      const idTokenResult = await user.getIdTokenResult()
      dispatch({ type: 'SET_CUSTOM_CLAIMS', payload: idTokenResult.claims})

      if (!isCancelled) {
        setIsPending(false)
        setError(null)
      }
      // successfully updated
      return true

    } catch (err) {
      if (!isCancelled) {
        setError(err.message)
        console.log(err)
        setIsPending(false)
      }
    }
  }
  useEffect(() => {

    return () => {
      setIsCancelled(true)
    }
  }, [])

  return { setCustomClaim, error, isPending }
}
